"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
/**
 * 全局的公共数据存储类
 */
var DataStore = /*#__PURE__*/(0, _createClass2.default)(function DataStore() {
  (0, _classCallCheck2.default)(this, DataStore);
  this.dataApiCache = {};
} // 数据源请求器的缓冲池，因为它是异步初始化的，不必重复
);
var _default = DataStore;
exports.default = _default;